import React, { useState, useEffect } from "react";
import "../CSS/Howitworks.css";
import { Grid } from "@mui/material";
import dotesImg from "../../Images/Dots.png";
// import { useThemeColors } from "../../Context/Theme";
import { READ_EVENT_HOWITWORKS, READ_HOWITWORKS } from "../../Api/apiConstant";
import { useGetAPIWithoutTokenQuery } from "../../Api/api";
import { isMobile } from "../../global/helpers";

const Howitworks = ({ isAtAllEvents, id, sx }) => {
  // const { textColor } = useThemeColors();

  const eventId = sessionStorage.getItem("event_id");
  const { data, isLoading } = useGetAPIWithoutTokenQuery(
    eventId && !isAtAllEvents
      ? `${READ_EVENT_HOWITWORKS}?event_id=${eventId}`
      : `${READ_HOWITWORKS}`, { refetchOnMountOrArgChange: true }
  );



  const [carousels, setCarousels] = useState([]);

  useEffect(() => {
    if (data?.data?.data?.length) {
      const apiData = data.data.data[0];
      const dynamicCarousels = [
        {
          id: 1,
          images: apiData.howitworkimg.tab_img_1.map(
            (img) => img.tab_img_path_1
          ),
          text: apiData.tab_descripation_1,
        },
        {
          id: 2,
          images: apiData.howitworkimg.tab_img_2.map(
            (img) => img.tab_img_path_2
          ),
          text: apiData.tab_descripation_2,
        },
        {
          id: 3,
          images: apiData.howitworkimg.tab_img_3.map(
            (img) => img.tab_img_path_3
          ),
          text: apiData.tab_descripation_3,
        },
      ];
      setCarousels(dynamicCarousels);
    }
  }, [data]);

  const isMob = isMobile()
  return (
    <div className="fo_css_event_how_it_works" id={isAtAllEvents ? id : ""} style={{ margin: isMob ? "80px 5px 80px 5px" : "80px", position: "relative" }}>
      <img
        src={dotesImg}
        alt="Dots"
        style={{
          width: "16%",
          position: "absolute",
          top: "16px",
          right: "0",
          zIndex: 1,
        }}
      />
      <p
        style={{
          fontWeight: sx.fontWeightHeading ? sx.fontWeightHeading : "700",
          fontSize: sx.fontSizeHeading ? sx.fontSizeHeading : "30px",
          textAlign: "center",
          color: sx.textColor || "black",
          fontFamily: sx.fontFamilyHeading,
        }}
      >
        How It Works
      </p>

      <Grid
        container
        spacing={2}
        style={{
          margin: "0px 20px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {carousels.map((carousel) => (
          <Grid item xs={12} md={4} key={carousel.id}>
            <CarouselWithText images={carousel.images} text={carousel.text} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const CarouselWithText = ({ images, text }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  const isMob = isMobile()
  return (
    <div className="fo_css_event_how_it_works" style={isMob ? { width: '80vw', height: '30vh', margin: '10px 0' } : {
      position: "relative",
      width: "30vw",
      height: "23vw",
      overflow: "hidden",
      borderRadius: "25px"
    }}>
      <div
        className="carousel-slide1"
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: isMob ? "100%" : "",
          height: isMob ? "30vh" : ""
        }}
      >
        {images?.length > 1 && (
          <>
            <button
              className="carousel-button next-button"
              onClick={prevSlide}
              style={{
                position: "absolute",
                top: "50%",
                left: "1vw",
                zIndex: 1,
                height: "5vh",
                width: "5vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={require("../../Images/arrowLeft.png")}
                style={{ objectFit: "contain", height: "2vh", width: "2vh" }}
              />
            </button>
            <button
              className="carousel-button next-button"
              onClick={nextSlide}
              style={{
                position: "absolute",
                top: "50%",
                right: "1vw",
                zIndex: 1,
                height: "5vh",
                width: "5vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={require("../../Images/arrowNew.png")}
                style={{ objectFit: "contain", height: "2vh", width: "2vh" }}
              />
            </button>
          </>
        )}
        <div className="carousel-text1">
          <div
            style={{
              fontWeight: "700",
              fontSize: "1.3em",
              width: "90%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            {text}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Howitworks;
